import React from "react";
import "../../../../styles/styles.css";
const Banner = () => {
  return (
    <div className="career-image-header">
      <span className="career-title">
       Behind every load and delivery is a team that makes it possible. Join ZOWO and help power logistics with speed, fairness, and heart.
      </span>
      <button className="book-now-button">
        <span>Get Hired</span>
      </button>
    </div>
  );
};
export default Banner;
